import { render, staticRenderFns } from "./PullShipments.vue?vue&type=template&id=88c24558&"
import script from "./PullShipments.vue?vue&type=script&lang=js&"
export * from "./PullShipments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports